import React from "react";
import { Container, Navbar, NavbarBrand } from "react-bootstrap";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { Link } from "react-router-dom";

interface IProps { }

interface IState { }

export default class Unauthorized extends React.Component<IProps, IState> {
    render() {
        return (
            <Container>
                <header>
                    <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3">
                        <Container>
                            <NavbarBrand as={Link} to="/">Physician Portal</NavbarBrand>
                            <NavbarToggle><span className="navbar-toggler-icon"></span></NavbarToggle>
                        </Container>
                    </Navbar>
                </header>
                <div>
                    You are unauthorized to view this page. If you believe you received this page in error, try logging out and logging back in again.
            </div>
            </Container>
        );
    }
}